var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"bem",rawName:"v-bem",value:(( _obj = {}, _obj[_vm.name] = true, _obj )),expression:"{ [name]: true }"}]})}
var staticRenderFns = []

export { render, staticRenderFns }